<template>
    <div>

        <vue-topprogress ref="loadingProgress"></vue-topprogress>

        <div class="animated fade-in" v-if="!loading && estimate">
            <h1 class="display-4 font-weight-lighter">Estimate #{{estimate.number}}</h1>
            <c-row v-if="isOpen(estimate)" class="my-4">
                <c-col md="4"><c-button @click="approveEstimate(estimate)" class="btn-success text-uppercase" block>APPROVE</c-button></c-col>
                <c-col md="4"><c-button @click="declineEstimate(estimate)" to="#" class="btn-sf text-uppercase" block>DECLINE</c-button></c-col>
            </c-row>
            <c-row class="my-4">
                <c-col>
                    <b-progress class="mt-2" :value="progress_value" height="30px">
                        <b-progress-bar
                                :key="index"
                                v-for="(item, index) in progress_items"
                                :value="100*(1/progress_items.length)"
                                :variant="(item.log ? item.log.estimate_status.getVariant : item.status.getVariant)"
                                :class="['estimate-progress',(index > (progress_value-1) ? 'muted' : '')]"
                        >
                            <div>{{ item.log ? item.log.estimate_status.name : item.status.name }}<span v-if="item.log"> ({{ item.log.created_at | moment('LL') }})</span></div>
                        </b-progress-bar>
                    </b-progress>
                </c-col>
            </c-row>
            <b-table
                    hover
                    class="my-4"
                    :items="estimate.estimate_items"
                    :fields="fields"
            >
                <template v-slot:cell(product)="data">
                    <document-preview
                            v-if="data.item.product && data.item.product.getPrimaryImage()"
                            :document="data.item.product.getPrimaryImage()"
                            class="d-inline-block float-left mr-3"
                            :width="100"
                    ></document-preview>
                    {{ data.item.getItemName() }}
                </template>
                <template v-slot:cell(price)="data">
                    ${{ data.value }}
                </template>
                <template v-slot:cell(total)="data">
                    ${{ data.value }}
                </template>
            </b-table>

        </div>

    </div>
</template>

<script>
    import Product from "../../models/Product";
    import Estimate from "../../models/Estimate";
    import EstimateItem from "../../models/EstimateItem";
    import EstimateStatusLog from "../../models/EstimateStatusLog";
    import EstimateStatus from "../../models/EstimateStatus";
    import DocumentPreview from "../../components/documents/DocumentPreview";
    import InsulationCut from "../../models/InsulationCut";
    import Contact from "../../models/Contact";
    import Location from "../../models/Location";

    export default {
      name: 'EstimateDetail',
      components: {DocumentPreview},
      data () {
        return {
          loading: true,
          estimate_id: this.$route.params.estimate_id,
          estimate: null,
          status_logs: null,
          progress_items: [],
          cancelled: false,
          progress_value: null,
          fields: [
            { key: 'product', label: 'Product' },
            { key: 'quantity', label: 'Quantity' },
            { key: 'price', label: 'Price' },
            { key: 'total', label: 'Total' }
          ],
          drops: {},
          notes: [],
          approve_status: null,
          decline_status: null,
        }
      },
	  methods: {
        fetch: function() {
          return Promise.all([
            Product.api().fetch({limit: 9999}),
            EstimateItem.api().fetch({estimate_id: this.estimate_id, limit: 9999}),
            EstimateStatusLog.api().fetch({estimate_id: this.estimate_id, limit: 9999}),
            EstimateStatus.api().fetch(),
            Estimate.api().retrieve(this.estimate_id),
          ]).then((results) => {
            let items = results[1].entities.estimate_items;
            let cuts = [];
            if(items && items.length) {
              items.forEach((item) => {
                if(item.insulation_cut_id) {
                  cuts.push(item.insulation_cut_id);
                }
              });
            }
            return Promise.all([
              InsulationCut.api().fetch({id: cuts.join('|')})
            ]);
          });
        },
        initStatuses: function() {
          this.status_logs = EstimateStatusLog.query().where('estimate_id', +(this.estimate_id)).orderBy('created_at').with(['estimate_status']).get();
          let highest = 0;
          let progress = 0;
          this.status_logs.forEach((log) => {
            if(log.estimate_status.position > highest) {
              highest = log.estimate_status.position;
            }
            this.progress_items.push({log});
            progress++;
          });
          this.progress_value = 100 * (progress / 100);
          let statuses = EstimateStatus.query().orderBy('position').where('position', value => value > highest).get();
          statuses.forEach((status) => {
            if(status.name === 'Approved') {
              this.approve_status = status;
            } else if(status.name === 'Declined') {
              this.decline_status = status;
            }
            this.progress_items.push({status});
          });
        },
        populate: function() {
          this.estimate = Estimate.query().whereId(+(this.estimate_id)).with([
            'estimate_items.product.images',
            'estimate_items.insulation_cut'
          ]).first();
          this.initStatuses();
        },
        init: function() {
          this.$refs.loadingProgress.start();
          this.loading = true;
          return this.fetch().then(() => {
            this.populate();
            this.$refs.loadingProgress.done();
            this.loading = false;
          });
        },
        getLastStatus(estimate) {
          let logs = estimate.estimate_status_logs;
          return (logs && logs.length ? logs[logs.length-1] : null);
        },
        isOpen(estimate) {
          let log = this.getLastStatus(estimate);
          return (log && log.status.name === 'Open');
        },
          approveEstimate(estimate) {
            EstimateStatusLog.api().create({
              estimate_id: estimate.id,
              estimate_status_id: this.approve_status.id
            }).then((results) => {
              this.quickSuccessToast('Estimate #'+estimate.number+' Approved', 'The estimate was approved successfully.');
              let log = results.entities.estimate_status_log;
              estimate.estimate_status_logs.push(log);
              EstimateStatusLog.api().export(log.id);
            },() => {
              this.quickWarningToast('Approval Failed', 'The estimate could not be approved, please try again.');
            });
          },
          declineEstimate(estimate) {
            EstimateStatusLog.api().create({
              estimate_id: estimate.id,
              estimate_status_id: this.decline_status.id
            }).then((results) => {
              this.quickSuccessToast('Estimate #'+estimate.number+' Declined', 'The estimate was declined successfully.');
              let log = results.entities.estimate_status_log;
              estimate.estimate_status_logs.push(log);
              EstimateStatusLog.api().export(log.id);
            },() => {
              this.quickWarningToast('Decline Failed', 'The estimate could not be declined, please try again.');
            });
          }
      },
      mounted() {
        this.init();
      },
      created() {
        this.loading = true;
      }
	}
</script>
<style>
.estimate-progress {
    font-size: 1.1em;
}
.muted {
    opacity: 0.2;
}
</style>